import { CommonModule, NgFor } from '@angular/common'
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { FileServices } from '../../../../@theme/services/file.service'
import { environment } from '../../../../../environments/environment'
import { PDFSERVICE } from '../../../../@theme/services/pdfgetfiles.service'
import { FormsModule, UntypedFormBuilder } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import * as CryptoJS from 'crypto-js'
import { PDFViewerComponent } from '../../pdfview.component'
import { FILE_ITEM_CLASS, SELECTED_FILE_ITEM_CLASS } from '../../file-list-classes'
declare let kendo: any
declare let $: any
@Component({
    selector: 'gd-licenceview',
    templateUrl: './lice.component.html',
    styleUrls: [
        './lice.component.scss',
        './../../disclosure-forms/disclosure-forms.component.scss',
    ],
    imports: [CommonModule, FormsModule,
        NgFor,
        PDFViewerComponent],
})
export class PDFLicenseViewerComponent
  implements OnInit
{
   @Output() onClientDriverlicenseChanged: EventEmitter<boolean> =
    new EventEmitter<boolean>()
      clientfiles: boolean
/*   @ViewChild('pdfViewerLAccount', { static: false }) */
  private pdfViewer
  public fileList: any[] = []
  public selectedFormData: Blob
  public pdfLoadError: string | null = null
  public selectedUrl: string | null = null
  public fileClass = FILE_ITEM_CLASS
  public selectedFileClass = SELECTED_FILE_ITEM_CLASS

  @Input() rawPdfDataviewerLice: Blob
  @Input() testbackout = 'the new data'
  @Input()
  FilePath: string
  @Input()
  outputClientId: string
  @Input()
  outputrepId: string
  @Input()
  outquery: string
  getpaths: string
  @Input()
  blotterId: string
  firstname: string
  lastname: string
  driverlicenseview: string
  clientName: string
  outputfiletrans: string
  outputdriverview: string
  private getloader: any
  get allowblotter(): string {
    return this.blotterId
  }
  set blotid(value: string) {
    this.blotterId = value
  }
  get allowDay(): string {
    return this.outputClientId
  }
  set clientId(value: string) {
    this.outputClientId = value
  }
  get allowrepid(): string {
    return this.outputrepId
  }
  set repid(value: string) {
    this.outputrepId = value
  }
  set quertn(value: string) {
    this.outquery = value
  }
  get allowquery(): string {
    return this.outquery
  }
  set filepaths(value: string) {
    this.FilePath = value
  }
  get getPath(): string {
    return this.FilePath
  }
  public BlotterName: number
 constructor(
    private pdfService: PDFSERVICE,
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    if (this.route.snapshot.queryParams['Rview']) {
      this.route.queryParams.subscribe((params) => {
        const getblotterClient = CryptoJS.AES.decrypt(
          params['Rview'],
          environment.securepw,
        ).toString(CryptoJS.enc.Utf8)
        this.blotterId = (getblotterClient)
        //   alert(JSON.stringify(this.blotId))
      })
    }
  }
  extractFileNames(filePaths: string[]): any[] {
    return filePaths.map((filePath) => {
      const parts = filePath.split('\\')
      const fileName = parts[parts.length - 1]
      return { name: fileName, url: filePath } // Assuming you want to keep the full filePath as the URL
    })
  }
  ngOnInit(): void {
    this.pdfService.getPdfDriverlicenselist(this.blotterId).subscribe((response) => {
      const fileNames = this.extractFileNames(response)
      this.fileList = fileNames
      if (response.length > 0 && this.fileList.length > 0) {
     //   this.clientfiles = true
        // Auto-select the first file so the viewer is never empty
        this.onClickFile(this.fileList[0].url)
      } else {
    //    this.clientfiles = false
      }
      this.onClientDriverlicenseChanged.emit(this.clientfiles)
    })
  }
  onClickFile(f: string) {
   this.selectedUrl = f
   const normalizedPath = f.replace(/\\/g, '/');
  const lowerPath = normalizedPath.toLowerCase();

  let relativePath = normalizedPath; // fallback

  const variants = ['filemanager/', 'file manager/'];
  for (const variant of variants) {
    const index = lowerPath.indexOf(variant);
    if (index !== -1) {
      relativePath = normalizedPath.substring(index + variant.length);
      break;
    }
  }

  const formNames: string[] = [relativePath];

    this.pdfService.viewDriverpdffile(formNames).subscribe({
      next: (response) => {
        this.selectedFormData = response;
        this.pdfLoadError = null;
      },
      error: (error) => {
        console.error('Error loading driver license PDF:', error);
        this.pdfLoadError = 'Cannot view this Driver License file because it is corrupted or unavailable';
        this.selectedFormData = null as any;
      }
    });
  }
}
